import { API_URLS } from "../../../Configs/apiUrls";
import axiosInstance from "../../../Configs/axios";

export const resonsForCancellationFn = (redBody) => {
  try {
    const response = axiosInstance.get(API_URLS.resonsForCancellation, redBody);
    return response;
  } catch ({ error }) {
    throw new Error(error.message);
  }
};
